document.addEventListener('jdgm.doneSetup', function () {
  document.querySelectorAll('.jdgm-preview-badge').forEach((badge) => {
    badge.addEventListener('click', (e) => {
      const questionTab = document.querySelector('.jdgm-subtab');
      if (e.target.parentNode.classList.contains('jdgm-qa-badge')) {
        questionTab.querySelector('span[data-tabname="questions"]').click();
      } else {
        questionTab.querySelector('span[data-tabname="reviews"]').click();
      }
    });
  });

  // ADA: Enhance Judge.me star rating badges with screen reader labels
  document.querySelectorAll('.jdgm-prev-badge').forEach(function (badge) {
    const stars = badge.querySelector('[data-average-rating]');
    const count = badge.querySelector('.jdgm-prev-badge__text');
    if (stars) {
      const rating = stars.getAttribute('data-average-rating') || '';
      const reviewCount = count ? count.textContent.trim() : '';
      let label = rating + ' out of 5 stars';
      if (reviewCount) label += ', ' + reviewCount;
      badge.setAttribute('aria-label', label);
      badge.setAttribute('role', 'link');
    }
  });

  // ADA 1.1.1: Add missing alt text to Judge.me verified reviewer badge images
  function patchJudgeMeVerifiedBadgeAlt() {
    document.querySelectorAll('img[src*="verified-badge"]').forEach(function (img) {
      if (!img.getAttribute('alt')) {
        img.setAttribute('alt', 'Verified reviewer');
      }
    });
  }
  patchJudgeMeVerifiedBadgeAlt();

  // ADA 4.1.2: Fix nested-interactive — summary stars container uses role="img" but
  // contains a focusable <a> link. Change role to "group" so the link is reachable.
  function patchJudgeMeSummaryStarsRole() {
    document.querySelectorAll('.jdgm-rev-widg__summary-stars[role="img"]').forEach(function (el) {
      el.setAttribute('role', 'group');
    });
  }
  patchJudgeMeSummaryStarsRole();

  // ADA 4.1.1 / ARIA: Judge.me injects <img role="presentation"> for the verified
  // badge count widget, but the img has meaningful alt text. `role="presentation"`
  // is not allowed on an img with a non-empty alt, so strip the role.
  function patchJudgeMeBadgeImgRole() {
    document.querySelectorAll('img[role="presentation"]').forEach(function (img) {
      const src = img.getAttribute('src') || '';
      if (src.includes('judge.public-static-assets') || src.includes('verified-badge')) {
        img.removeAttribute('role');
      }
    });
  }
  patchJudgeMeBadgeImgRole();

  // Also catch any dynamically injected badges or summary stars widgets.
  // Debounce to avoid running querySelectorAll on every individual mutation.
  let jdgmPatchTimer;
  const observer = new MutationObserver(function () {
    clearTimeout(jdgmPatchTimer);
    jdgmPatchTimer = setTimeout(function () {
      patchJudgeMeVerifiedBadgeAlt();
      patchJudgeMeSummaryStarsRole();
      patchJudgeMeBadgeImgRole();
    }, 200);
  });
  // Observe the narrowest Judge.me root available; fall back to body
  const jdgmRoot = document.querySelector('.jdgm-widget, [class^="jdgm"]') || document.body;
  observer.observe(jdgmRoot, { childList: true, subtree: true });
});
